export const isAssistantPageRoute = (pathname: string): boolean =>
  pathname === "/[orgSlug]/assistant" || pathname.startsWith("/[orgSlug]/assistant/");
